import * as React from "react";
import {Icon} from "semantic-ui-react";
import {CustomerReportDynamicSection, healthyHighlighter, lifecycleStatusDisplay} from "../CustomerReportDynamicSection";
import {
    AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest
} from "../../../../../../generated";
import ServiceTypeEnum = AddOrRemoveCompaniesFromIgnoreListForCustomerReportRequest.ServiceTypeEnum;
import {customerReport} from "../../../../../style/page_with_sidebar";

export function SchedulerReportTaskStatus({ reFetchReportData }: { reFetchReportData: () => Promise<void> }) {

    function drawSimpleBoolean(b: boolean) {
        if (b) {
            return <Icon name={'check'} color={'green'}/>
        } else {
            return <Icon name={'x'} color={'red'}/>
        }
    }

    function allTasksHealthy(tasks: any[]) {
        return tasks.filter((value) => {
            return value.state != null
        }).every(task => task.state == "OK")
    }

    const columns = [{
        id: 'id',
        Header: 'id',
        width: 250,
        accessor: (d: any) => d.companyId,
    }, {
        id: 'companyName',
        Header: 'companyName',
        width: 300,
        accessor: (d: any) => d.companyName,
    }, {
        id: 'lifecycleStatus',
        Header: 'Lifecycle Status',
        width: 120,
        accessor: (d: any) => lifecycleStatusDisplay(d),
    }, {
        id: 'healthy',
        Header: 'healthy',
        width: 70,
        accessor: (d: any) =>
            <div>{healthyHighlighter(allTasksHealthy(d.tasks))}</div>,
    }, {
        id: 'amountOfTasks',
        Header: 'amountOfTasks',
        width: 70,
        accessor: (d: any) =>
            <div>{d.tasks.length}</div>,
    }
    ]

    return <>
        <CustomerReportDynamicSection
            columns={columns}
            data={customerReport.value?.schedulerReportTaskStatus?.companies}
            currentService={ServiceTypeEnum.STATUSJSONREPORT}
            reFetchReportData={reFetchReportData}
        />
    </>


}